// import api from 'api';
import api from "./../api";

import Swal from "sweetalert2";
import UtilsUrl from "../../utils/UtilsUrl";

const getEmployeeWithNoCrew = (idUser) => {
  return api.get(UtilsUrl.rhURL() + "/employees/hasNoCrew/" + idUser);
};
const insertCrew = async (formData) => {
  return await api.post(UtilsUrl.rhURL() + "/crews/add_crew", formData);
};
const checkNomEquipe = async (nomEquipe, idUser) => {
  return await api.get(
    UtilsUrl.rhURL() + `/crews/check-nom-equipe/${nomEquipe}/${idUser}`
  );
};
const getCrews = async (idUser) => {
  return api.get(UtilsUrl.rhURL() + "/crews/" + idUser);
};
const planningTime = (idUser, formData) => {
  return api.put(
    UtilsUrl.rhURL() + "/crews/saveTimePlaning/" + idUser,
    formData
  );
};
const affectEmployeeToCrew = (idUser, formData) => {
  return api.post(
    UtilsUrl.rhURL() + "/crews/affect-employee-to-crew/" + idUser,
    formData
  );
};
const updateCrew = async (id, crew) => {
  return await api.put(UtilsUrl.rhURL() + `/crews/updateCrew/${id}`, crew);
};
const deleteCrew = async (crewID, setCrewNames) => {
  try {
    const result = await Swal.fire({
      title: "Es-tu sûr?",
      text: "Vous ne pourrez pas annuler cette action !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Oui, supprimez-le !",
      cancelButtonText: "Non, annulez !",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      await api.put(UtilsUrl.rhURL() + `/crews/archiveCrew/${crewID}`, {
        isDeleted: true,
      });

      Swal.fire("Supprimé !", "Equipe archiver avec succès.", "success");

      setCrewNames((prevState) =>
        prevState.filter((crewName) => crewName.idEquipe !== crewID)
      );
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      Swal.fire("Cancelled", "Your file is safe :)", "error");
    }
  } catch (error) {
    console.error(error);
  }
};
const getCrewInfoById = (idEquipe) => {
  return api.get(UtilsUrl.rhURL() + `/crews/crew/${idEquipe}`);
};
const updateEmployeeCrew = async (id, empl) => {
  return await api.put(
    UtilsUrl.rhURL() + `/crews/modifierEquipeEmployee/${id}`,
    empl
  );
};

const DeleteEmployeeCrew = async (idEmpl, setCrewDetail, crewDetail) => {
  try {
    const result = await Swal.fire({
      title: "Es-tu sûr?",
      text: "Vous ne pourrez pas annuler cette action !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Oui, supprimez-le !",
      cancelButtonText: "Non, annulez !",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      await api.put(
        UtilsUrl.rhURL() + `/crews/SupprimerCrewEmployee/${idEmpl}`,
        {
          dept: null,
        }
      );
      Swal.fire("Supprimé !", "Equipe archiver avec succès.", "success");

      const updatedEmployees = crewDetail.employees.filter(
        (employee) => employee.id !== idEmpl
      );
      setCrewDetail((prevState) => ({
        ...prevState,
        employees: updatedEmployees,
      }));
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      Swal.fire("Cancelled", "Your file is safe :)", "error");
    }
  } catch (error) {
    console.error(error);
  }
};
const getEmployeeCrew = async (idUser) => {
  try {
    const response = await api.get(
      UtilsUrl.rhURL() + `/employees/EmployeeCrew/${idUser}`
    );
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};
export {
  getEmployeeWithNoCrew,
  insertCrew,
  checkNomEquipe,
  getCrews,
  planningTime,
  affectEmployeeToCrew,
  updateCrew,
  deleteCrew,
  getCrewInfoById,
  updateEmployeeCrew,
  DeleteEmployeeCrew,
  getEmployeeCrew,
};
